import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { Tracker } from "../../../util/analytics";
import { API_ENDPOINTS } from "../../../util/constants";
import { getUser } from "../../../util/helpers";
import { actions } from "../../Dashboard/_redux/dashboardRedux";

const initialListingsState = {
  selectedStatus: {},
  customBreakOptions: [{ label: "No-Answer Break", value: "No-Answer Break" }],
  statusToastInfo: {
    open: false,
    severity: "info",
    snackbarMessage: "",
  },
};

export const updateUserStatus = createAsyncThunk(
  "userProfileSlice/updateUserStatus",
  async (params, { dispatch, rejectWithValue }) => {
    const { selectedStatus } = params;
    const paramObj = {
      user_id: `${params.userId}`,
      value: selectedStatus.value,
      property: "status",
      ...params?.customBreak,
    };

    try {
      const response = await axios.post(
        API_ENDPOINTS.updateAccountStatus,
        paramObj,
        { headers: { ...params?.headers } }
      );

      dispatch(
        setSelectedStatus({
          value: selectedStatus.value,
          label: selectedStatus.label,
        })
      );

      dispatch(
        actions.setLoadingState({
          resource: "update_userStatus",
          loading_state: "loaded",
        })
      );
      Tracker.event(
        "My Status Click",
        "Click",
        "My Status",
        selectedStatus["value"],
        getUser()
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "update_userStatus",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const userProfileSlice = createSlice({
  name: "userProfileSlice",
  initialState: { ...initialListingsState },

  reducers: {
    setSelectedStatus: (state, action) => {
      const { payload } = action;
      state.selectedStatus = payload;
    },
    setCustomBreakOptions: (state, action) => {
      const { payload } = action;
      state.customBreakOptions = [
        { label: "No-Answer Break", value: "No-Answer Break", disabled: true },
        ...payload,
      ];
    },
    setToastInfoForAccountStatus: (state, action) => {
      const { payload } = action;
      state.statusToastInfo = payload;
    },
  },
});
export const {
  setSelectedStatus,
  setCustomBreakOptions,
  setToastInfoForAccountStatus,
} = userProfileSlice.actions;
export default userProfileSlice.reducer;
